import I18n from 'I18n';
import once from 'transmute/once';
// @ts-expect-error untyped
import * as ObjectSegConstants from '../../objectSeg/constants/constants';
import MissingField from '../../../filterQueryFormat/MissingField';
export default once(() => MissingField({
  name: ObjectSegConstants.MISSING_ASSOCIATION_BRANCH_FILTER,
  label: I18n.text('customerDataFilters.FilterMissingAssociationBranch.filterLabel')
}));